<template>
  <v-container>
    <v-layout row wrap>
      <v-flex md8>
        <h4 class="headline mb-4 mt-2">
          Segmentos globales
        </h4>
      </v-flex>
      <v-flex md4 class="text-xs-right">
        <v-btn class="k-orange-linear mr-0" @click="createStage(true)">
          Crear segmento
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap mb-4>
      <v-flex xs12>
        <stages-list
          :key="stagesKey"
          :stages="globalStages"
          :is-whatsapp-outbound-active="isWhatsappOutboundActive"
          @select-stage="selectedStageId = $event.id"
          @commute-stage="commuteStage"
          @edit-stage="editStage"
          @delete-stage="deleteStage"
          @commute-filter="commuteFilter"
          @create-filter="createFilter"
          @edit-filter="editFilter"
          @delete-filter="deleteFilter" />
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex md8>
        <h4 class="headline mb-4 mt-2">
          Segmentos normales
        </h4>
      </v-flex>
      <v-flex md4 class="text-xs-right">
        <v-btn class="k-orange-linear mr-0" @click="createStage(false)">
          Crear segmento
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <stages-list
          :key="stagesKey"
          :stages="normalStages"
          :is-whatsapp-outbound-active="isWhatsappOutboundActive"
          @select-stage="selectedStageId = $event.id"
          @commute-stage="commuteStage"
          @edit-stage="editStage"
          @delete-stage="deleteStage"
          @commute-filter="commuteFilter"
          @create-filter="createFilter"
          @edit-filter="editFilter"
          @delete-filter="deleteFilter" />
      </v-flex>
    </v-layout>
    <stage-modal
      :show="stageModal"
      :global="selectedStageGlobal"
      :stage="selectedStage"
      :max-order="maxOrderStage"
      @created="$emit('stage-created', $event)"
      @updated="$emit('stage-updated', $event)"
      @close="stageModal = false"/>
    <filter-modal
      :show="filtersModal"
      :stage="selectedStage"
      :filter="selectedFilter"
      :template-id="templateId"
      :is-whatsapp-outbound-active="isWhatsappOutboundActive"
      @created="$emit('filter-created', selectedStage, $event)"
      @updated="$emit('filter-updated', selectedStage, $event)"
      @close="filtersModal = false" />
    <delete-dialog
      :show="deleteModal"
      :url="deleteUrl"
      :message="deleteMessage"
      @deleted="deletedEvt"
      @close="deleteModal = false"/>
  </v-container>
</template>

<script>
import _ from 'lodash';
import StageModal from '@/components/V2CollectWorkflows/Detail/WorkflowTree/StageModal';
import StagesList from '@/components/V2CollectWorkflows/Detail/WorkflowTree/StagesList';
import FilterModal from '@/components/V2CollectWorkflows/Detail/WorkflowTree/FilterModal';
import DeleteDialog from '@/components/global/DeleteDialog2';

export default {
  props: {
    workflow: {
      type: Object,
      required: true,
    },
    stages: {
      type: Array,
      required: true,
    },
    stagesKey: {
      type: String,
      required: true,
    },
    isWhatsappOutboundActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    StageModal,
    StagesList,
    FilterModal,
    DeleteDialog,
  },
  data() {
    return {
      selectedStageGlobal: false,
      stageModal: false,
      filtersModal: false,
      selectedStageId: 0,
      selectedFilter: {},
      deleteModal: false,
      deleteType: 'stage',
      templateId: 0,
    };
  },
  computed: {
    getTempalteId () {
      return (this.filter.template || {}).id;
    },
    globalStages() {
      return _.sortBy(this.stages.filter(item => item.global), item => parseInt(item.order, 10));
    },
    normalStages() {
      return _.sortBy(this.stages.filter(item => !item.global), item => parseInt(item.order, 10));
    },
    maxOrderStage() {
      let maxOrder;
      if (this.selectedStageGlobal) {
        maxOrder = this.globalStages.length;
      } else {
        maxOrder = this.normalStages.length;
      }
      return maxOrder + 1;
    },
    selectedStage() {
      const stage = this.stages.find(item => item.id === this.selectedStageId) || {};
      if (Object.keys(stage).length && typeof (stage.stage_filters) === 'string') {
        stage.stage_filters = JSON.parse(stage.stage_filters || JSON.stringify({
          type: 'group',
          operator: 'and',
          items: [],
        }));
      }
      return stage;
    },
    deleteUrl() {
      let url = '';
      if (this.deleteType === 'stage') {
        url = `stages/${this.selectedStage.id}`;
      } else {
        url = `v2/workflow_filters/${this.selectedFilter.id}`;
      }
      return url;
    },
    deleteMessage() {
      let message = '';
      if (this.deleteType === 'stage') {
        message = `¿Esta seguro de que desea eliminar el segmento días de mora ${this.selectedStage.name || 'Prueba'}? Se borraran todos los filtros y plantillas asociadas. Esta acción es irreversible`;
      } else {
        message = `¿Esta seguro de que desea eliminar la estrategia ${this.selectedFilter.name}? Se borraran todas las plantillas asociadas. Esta acción es irreversible`;
      }
      return message;
    },
  },
  methods: {
    createStage(isGlobal) {
      this.selectedStageId = 0;
      this.selectedStageGlobal = isGlobal;
      this.stageModal = true;
    },
    editStage(stage) {
      this.selectedStageId = stage.id;
      this.selectedStageGlobal = !!stage.global;
      this.stageModal = true;
    },
    commuteStage(stage) {
      this.axios.patch(`stages/${stage.id}`, {
        status: stage.status === 'Activo' ? 'Inactivo' : 'Activo',
      }).then((response) => {
        this.$emit('stage-updated', response.data);
      }).catch(() => {});
    },
    deleteStage(stage) {
      this.selectedStageId = stage.id;
      this.deleteType = 'stage';
      this.deleteModal = true;
    },
    commuteFilter(stage, filter) {
      this.axios.patch(`v2/workflow_filters/${filter.id}`, {
        status: filter.status === 'Activo' ? 'Inactivo' : 'Activo',
      }).then((response) => {
        this.$emit('filter-updated', stage, response.data);
      }).catch(() => {});
    },
    createFilter(stage) {
      this.selectedStageId = stage.id;
      this.selectedFilter = {};
      this.filtersModal = true;
    },
    editFilter(filter) {
      const template = filter.template || {};
      const tmp = {
        ..._.pick(filter, [
          'id',
          'name',
          'order',
          'status',
          'bot_template_id',
          'ivr_template_id',
          'whatsapp_template_id',
          'send_human',
          'send_bot',
          'send_email',
          'send_sms',
          'send_ivr',
          'send_visit',
          'send_whatsapp',
          'days_off',
          'valid_only_sms',
          'only_contacted_sms',
          'bot_calls_queue',
          'ivr_calls_queue',
          'bot_max_attempts',
          'ivr_max_attempts',
          'days_off_g1',
          'days_off_g2',
          'days_off_g3',
          'days_off_g4',
          'days_off_g5',
          'fixed_hour',
          'type_id',
          'sms_cs_journey',
          'sms_check_days',
          'sms_owner_id',
          'ivr_owner_id',
          'bot_owner_id',
          'human_owner_id',
          'whatsapp_owner_id',
        ]),
        ..._.pick(template, [
          'company_email_id',
          'subject',
          'email',
          'sms',
          'ivr',
          'human',
          'visit',
        ]),
        no_management: !!filter.no_management,
        template_id: template.id,
        filters: JSON.parse(filter.filters || JSON.stringify({
          type: 'group',
          operator: 'and',
          items: [],
        })),
      };
      this.templateId = template.id;
      this.selectedFilter = tmp;
      this.filtersModal = true;
    },
    deleteFilter(filter) {
      this.selectedFilter = filter;
      this.deleteType = 'filter';
      this.deleteModal = true;
    },
    deletedEvt() {
      this.deleteModal = false;
      this.$emit(`${this.deleteType}-deleted`, ...[
        this.selectedStage,
        ...this.deleteType === 'filter' && [
          this.selectedFilter,
        ],
      ]);
      if (this.deleteType === 'stage') {
        this.selectedStageId = 0;
      } else {
        this.selectedFilter = {};
      }
    },
  },
  watch: {
    filtersModal() {
      if (!this.filtersModal) {
        this.selectedFilter = {};
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/WorkflowTree/Index.vue